// This module owns the Meta Pixel. Do not install the same pixel through GTM.
export const metaPixelId = '1829821498041742';
const scriptUrl = 'https://connect.facebook.net/en_US/fbevents.js';
const productionHosts = /^(www\.)?palmate\.ai$/i;
const leadForms = new Set(['demo', 'quote', 'contact']);

function productionPage() {
  if (typeof window === 'undefined') return null;
  try {
    const url = new URL(window.location.href);
    if (!productionHosts.test(url.hostname)) return null;
    url.hash = '';
    return url.href;
  } catch { return null; }
}

function flush(state) {
  if (!state.ready || !state.consent) return;
  if (!state.initialized) {
    // Only explicit PageView and Lead events; do not infer conversions from button clicks.
    window.fbq('set', 'autoConfig', false, metaPixelId);
    window.fbq('init', metaPixelId);
    state.initialized = true;
  }
  window.fbq('consent', 'grant');
  for (const event of state.pending.splice(0)) window.fbq('trackSingle', metaPixelId, ...event);
}

function loadPixel(state) {
  if (typeof window.fbq?.callMethod === 'function') {
    state.ready = true;
    return;
  }
  if (!window.fbq) {
    const fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    fbq.push = fbq; fbq.loaded = true; fbq.version = '2.0'; fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
  }
  const script = document.createElement('script');
  script.async = true;
  script.dataset.palmateMetaPixel = metaPixelId;
  script.src = scriptUrl;
  script.onload = () => { state.ready = true; flush(state); };
  script.onerror = () => { state.pending = []; };
  document.head.appendChild(script);
}

export function updateMetaPixel(marketing) {
  const page = productionPage();
  if (!page) return;
  let state = window.__palmateMetaPixel;
  if (marketing !== true) {
    if (!state) return;
    state.consent = false;
    state.lastPage = null;
    // A slow script must not send events collected before consent was withdrawn.
    state.pending = [];
    if (state.initialized) window.fbq('consent', 'revoke');
    return;
  }
  if (!state) {
    state = window.__palmateMetaPixel = { ready: false, initialized: false, consent: true, pending: [], lastPage: null, leads: new Set() };
    loadPixel(state);
  }
  state.consent = true;
  if (state.lastPage !== page) {
    state.lastPage = page;
    // Before the library is ready, only the currently visible page can be measured accurately.
    if (!state.ready) state.pending = state.pending.filter(event => event[0] !== 'PageView');
    state.pending.push(['PageView']);
  }
  flush(state);
}

export function trackMetaLead(name, params = {}) {
  if (!productionPage() || window.__palmateConsent?.marketing !== true) return;
  const state = window.__palmateMetaPixel;
  if (!state?.consent || name !== 'generate_lead' || !leadForms.has(params.form_type)) return;
  const id = params.event_id;
  if (typeof id !== 'string' || !/^lead_[a-zA-Z0-9_-]{1,100}$/.test(id) || state.leads.has(id)) return;
  state.leads.add(id);
  // Never forward form fields, first-touch records or contact details to Meta.
  state.pending.push(['Lead', { content_category: params.form_type }, { eventID: id }]);
  flush(state);
}
